import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Typography,
  TableHead,
  TableRow,
  withStyles,
  Grid,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  countOrACVFormatter,
  StyledTableRow,
  _isNaN,
  getUniqueValues,
} from "../../../../util/customFunctions";
import CopyTablesObject from "../../../../components/xlsx-export/CopyTablesObject";

const styles = makeStyles({
  tableHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px 5px",
    color: "inherit",
  },
  nonScoreCell: {
    fontWeight: 400,
    border: "0.5px solid lightgrey",
    padding: "7px 10px",
    color: "inherit",
  },
  repHeader: {
    fontSize: "0.85rem",
    border: "0.5px solid lightgrey",
    padding: "7px 10px",
    color: "inherit",
    width: 120,
    fontWeight: 600,
  },
  repHeaderDrilldown: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "7px 10px",
    color: "inherit",
    width: 120,
    cursor: "pointer",
  },
  repNameMargin: {
    paddingLeft: "1.75rem",
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "7px 10px",
    color: "inherit",
    width: 120,
  },
  mainTable: {
    width: "100%",
    maxWidth: "100%",
    padding: "0.25rem",
  },
  "& .MuiTableCell-sizeSmall": {
    padding: "6px 24px 6px 10px;",
  },
});

export default function AttainmentTable(props) {
  const classes = styles();
  const tableRef = React.createRef();
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const tableContainer = document.getElementById("myTableContainer");

    const handleOverflowCheck = () => {
      if (tableContainer) {
        setIsOverflowing(
          tableContainer.scrollWidth > tableContainer.offsetWidth
        );
      }
    };

    // Check for overflow initially and whenever the component updates
    handleOverflowCheck();

    // Attach a resize event listener to check for overflow when the window is resized
    window.addEventListener("resize", handleOverflowCheck);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener("resize", handleOverflowCheck);
    };
  }, []);

  const teams = props.AttainmentTable.map((s) => s.name)
    .filter(getUniqueValues)
    .sort();
  // const bookingTypes=props.AttainmentTable.map(s=>s.type).filter(getUniqueValues).filter(a=>a !== 'total')
  const bookingTypes = props.attainmentSplitUp;
  // const uniqueNames=["New Logo","Cross Sell","Upsell","Price Increase"]
  const uniqueNames = props.attainmentSplitUp;
  const countAndOpps = (
    <>
      {Array(1)
        .fill()
        .map((item) => (
          <>
            <TableCell
              align="center"
              className={classes.repHeader}
              colSpan={1}
              style={{
                background: "#70AD47",
                color: "white",
                border: "0.5px solid lightgrey",
                minWidth: 40,
                maxWidth: 40,
              }}
            >
              # of Opps
            </TableCell>
            <TableCell
              align="center"
              className={classes.repHeader}
              colSpan={1}
              style={{
                background: "#70AD47",
                color: "white",
                border: "0.5px solid lightgrey",
                minWidth: 70,
                maxWidth: 70,
              }}
            >
              ACV
            </TableCell>
          </>
        ))}
    </>
  );
  const countAndOppsAndPercentage = (
    <>
      {uniqueNames.map((item, i) => (
        <>
          <TableCell
            align="center"
            className={classes.repHeader}
            colSpan={1}
            style={{
              background: "#70AD47",
              color: "white",
              border: "0.5px solid lightgrey",
              minWidth: 40,
              maxWidth: 40,
            }}
          >
            # of Opps
          </TableCell>
          <TableCell
            align="center"
            className={classes.repHeader}
            colSpan={1}
            style={{
              background: "#70AD47",
              color: "white",
              border: "0.5px solid lightgrey",
              minWidth: 70,
              maxWidth: 70,
            }}
          >
            ACV
          </TableCell>
          {/* <TableCell align='center' className={classes.repHeader} colSpan={1} style={{ background: i%2 == 0 ? '#4471C4' : '#5B9BD5', color: 'white',border: '0.5px solid lightgrey',minWidth:50,maxWidth:50  }}>% of Tot.</TableCell> */}
        </>
      ))}
    </>
  );
  return (
    <>
      {props.AttainmentTable !== "" &&
        props.selectedTeam !== undefined &&
        props.selectedRep !== undefined && (
          <>
            {isOverflowing ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "right",
                  marginBottom: "10px",
                  // marginRight: "2rem",
                }}
              >
                <CopyTablesObject tableRef={tableRef} />
              </div>
            ) : null}
            <TableContainer
              style={{ paddingBottom: "1rem" }}
              id="myTableContainer"
            >
              {isOverflowing === false ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "10px",
                    // marginRight: "10px",
                  }}
                >
                  <CopyTablesObject tableRef={tableRef} />
                </div>
              ) : null}
              <Table
                ref={tableRef}
                size="small"
                aria-label="html table"
                style={{ tableLayout: "auto" }}
                data-test={props.dataTest}
              >
                <TableHead></TableHead>
                <TableBody>
                  <StyledTableRow>
                    <TableCell
                      align="center"
                      rowSpan={2}
                      className={classes.repHeader}
                      colSpan={1}
                      style={{
                        background: "#DDECB9",
                        height: 90,
                        minWidth: 160,
                        border: "0.5px solid lightgrey",
                      }}
                    >
                      {props.tableHeader}
                    </TableCell>
                    <TableCell
                      align="center"
                      rowSpan={2}
                      className={classes.repHeader}
                      colSpan={1}
                      style={{
                        background: "#4472c4",
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 50,
                        maxWidth: 50,
                      }}
                    >
                      Goal
                    </TableCell>
                    <TableCell
                      align="center"
                      rowSpan={2}
                      className={classes.repHeader}
                      colSpan={1}
                      style={{
                        background: "#4472c4",
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 50,
                        maxWidth: 50,
                      }}
                    >
                      Actual
                    </TableCell>
                    <TableCell
                      align="center"
                      colSpan={2}
                      className={classes.repHeader}
                      style={{
                        background: "#70AD47",
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 120,
                        maxWidth: 120,
                      }}
                    >
                      Total Actual ACV
                    </TableCell>
                    {/* <TableCell align='center' rowSpan={2} className={classes.repHeader}  style={{ background: '#70AD47', color: 'white',border: '0.5px solid lightgrey',minWidth:60,maxWidth:60 }}>Attain. %</TableCell> */}
                    {uniqueNames.map((s, i) => {
                      return (
                        <>
                          <TableCell
                            align="center"
                            className={classes.repHeader}
                            colSpan={2}
                            style={{
                              background: "#70AD47",
                              color: "white",
                              border: "0.5px solid lightgrey",
                              minWidth: 150,
                              maxWidth: 150,
                            }}
                          >
                            {s}
                          </TableCell>
                        </>
                      );
                    })}
                    <TableCell
                      align="center"
                      rowSpan={2}
                      className={classes.repHeader}
                      colSpan={1}
                      style={{
                        background: "#70AD47",
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 50,
                        maxWidth: 50,
                      }}
                    >
                      Actual Services
                    </TableCell>
                    <TableCell
                      align="center"
                      rowSpan={2}
                      className={classes.repHeader}
                      colSpan={1}
                      style={{
                        background: "#70AD47",
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 50,
                        maxWidth: 50,
                      }}
                    >
                      <p>Bookings</p>
                      <p>(3*ACV + Services)</p>
                    </TableCell>
                    <TableCell
                      align="center"
                      rowSpan={2}
                      className={classes.repHeader}
                      colSpan={1}
                      style={{
                        background: "#bf8f00",
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 50,
                        maxWidth: 50,
                      }}
                    >
                      <p>Quota</p>
                      <p>(Bookings)</p>
                    </TableCell>
                  </StyledTableRow>
                  <TableRow>
                    {countAndOpps}
                    {countAndOppsAndPercentage}
                  </TableRow>
                  <StyledTableRow>
                    <TableCell
                      align="left"
                      className={classes.repHeader}
                      style={{
                        border: "0.5px solid lightgrey",
                        fontWeight: 600,
                      }}
                      colSpan={1}
                    >
                      {props.selectedTeam.includes("All") &&
                      props.selectedRep.includes("All")
                        ? "Company"
                        : !props.selectedTeam.includes("All")
                        ? props.selectedTeam.length > 1
                          ? "Teams"
                          : "Team"
                        : "Total"}
                    </TableCell>
                    <TableCell
                      align="right"
                      className={classes.repHeader}
                      style={{
                        border: "0.5px solid lightgrey",
                        paddingRight: "0.5rem",
                      }}
                      colSpan={1}
                    >
                      {"100%"}
                    </TableCell>
                    <TableCell
                      align="right"
                      className={classes.repHeader}
                      style={{
                        border: "0.5px solid lightgrey",
                        paddingRight: "0.5rem",
                      }}
                      colSpan={1}
                    >
                      {Math.round(props.AttainmentSegmentRow[0].actual * 100)}%
                    </TableCell>
                    <TableCell
                      align="right"
                      onClick={() =>
                        props.handleChangeLocation(
                          "drilldownOnGraph",
                          bookingTypes,
                          teams
                        )
                      }
                      className={classes.repHeader}
                      style={{
                        border: "0.5px solid lightgrey",
                        cursor: "pointer",
                        paddingRight: "0.5rem",
                      }}
                      colSpan={1}
                    >
                      {countOrACVFormatter(
                        props.AttainmentSegmentRow[0].attainmentCount
                      )}
                    </TableCell>
                    <TableCell
                      align="right"
                      onClick={() =>
                        props.handleChangeLocation(
                          "drilldownOnGraph",
                          bookingTypes,
                          teams
                        )
                      }
                      className={classes.repHeader}
                      style={{
                        border: "0.5px solid lightgrey",
                        cursor: "pointer",
                        paddingRight: "0.5rem",
                      }}
                      colSpan={1}
                    >
                      $
                      {countOrACVFormatter(
                        props.AttainmentSegmentRow[0].attainmentAcv
                      )}
                    </TableCell>
                    {/* <TableCell align='right' onClick={() => props.handleChangeLocation("drilldownOnGraph", bookingTypes)} className={classes.repHeader} style={{border: '0.5px solid lightgrey',cursor:'pointer',paddingRight:'0.5rem'}} colSpan={1}>{Math.round(props.AttainmentSegmentRow[0].attainmentPerc * 100)}%</TableCell> */}
                    {uniqueNames.map((s) => {
                      return (
                        <>
                          <TableCell
                            align="right"
                            onClick={() =>
                              props.handleChangeLocation(
                                "drilldownOnGraph",
                                [s],
                                teams
                              )
                            }
                            className={classes.repHeader}
                            style={{
                              border: "0.5px solid lightgrey",
                              cursor: "pointer",
                              paddingRight: "0.5rem",
                            }}
                            colSpan={1}
                          >
                            {countOrACVFormatter(
                              props.AttainmentSegmentRow.filter(
                                (i) => i.type === s
                              )[0].count
                            )}
                          </TableCell>
                          <TableCell
                            align="right"
                            onClick={() =>
                              props.handleChangeLocation(
                                "drilldownOnGraph",
                                [s],
                                teams
                              )
                            }
                            className={classes.repHeader}
                            style={{
                              border: "0.5px solid lightgrey",
                              cursor: "pointer",
                              paddingRight: "0.5rem",
                            }}
                            colSpan={1}
                          >
                            $
                            {countOrACVFormatter(
                              props.AttainmentSegmentRow.filter(
                                (i) => i.type === s
                              )[0].acv
                            )}
                          </TableCell>
                          {/* <TableCell align='right' onClick={() => props.handleChangeLocation("drilldownOnGraph", [s])} className={classes.repHeader} style={{border: '0.5px solid lightgrey',cursor:'pointer',paddingRight:'0.5rem' }} colSpan={1}>{Math.round(props.AttainmentSegmentRow.filter(i=>i.type === s)[0].perc * 100)}%</TableCell> */}
                        </>
                      );
                    })}
                    <TableCell
                      align="right"
                      onClick={() =>
                        props.handleChangeLocation(
                          "drilldownOnGraph",
                          bookingTypes,
                          teams
                        )
                      }
                      className={classes.repHeader}
                      style={{
                        border: "0.5px solid lightgrey",
                        cursor: "pointer",
                        paddingRight: "0.5rem",
                      }}
                      colSpan={1}
                    >
                      $
                      {countOrACVFormatter(
                        props.AttainmentSegmentRow[0].services
                      )}
                    </TableCell>
                    <TableCell
                      align="right"
                      className={classes.repHeader}
                      style={{
                        border: "0.5px solid lightgrey",
                        paddingRight: "0.5rem",
                      }}
                      colSpan={1}
                    >
                      $
                      {countOrACVFormatter(
                        props.AttainmentSegmentRow[0].bookings
                      )}
                    </TableCell>
                    <TableCell
                      align="right"
                      className={classes.repHeader}
                      style={{
                        border: "0.5px solid lightgrey",
                        paddingRight: "0.5rem",
                      }}
                      colSpan={1}
                    >
                      $
                      {countOrACVFormatter(props.AttainmentSegmentRow[0].quota)}
                    </TableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <TableCell
                      align="left"
                      className={classes.nonScoreCell}
                      style={{
                        border: "0.5px solid lightgrey",
                        fontWeight: 600,
                      }}
                      colSpan={1}
                    >
                      {props.selectedTeam.includes("All") &&
                      props.selectedRep.includes("All")
                        ? "Teams"
                        : "Reps"}
                    </TableCell>
                    <TableCell
                      align="center"
                      rowSpan={1}
                      className={classes.repHeader}
                      colSpan={1}
                      style={{
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 50,
                        maxWidth: 50,
                      }}
                    ></TableCell>
                    {Array(1)
                      .fill()
                      .map((item) => (
                        <>
                          <TableCell
                            align="center"
                            className={classes.repHeader}
                            colSpan={1}
                            style={{
                              color: "white",
                              border: "0.5px solid lightgrey",
                              minWidth: 40,
                              maxWidth: 40,
                            }}
                          ></TableCell>
                          <TableCell
                            align="center"
                            className={classes.repHeader}
                            colSpan={1}
                            style={{
                              color: "white",
                              border: "0.5px solid lightgrey",
                              minWidth: 70,
                              maxWidth: 70,
                            }}
                          ></TableCell>
                        </>
                      ))}
                    <TableCell
                      align="center"
                      rowSpan={1}
                      className={classes.repHeader}
                      style={{
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 60,
                        maxWidth: 60,
                      }}
                    ></TableCell>
                    {uniqueNames.map((item, i) => (
                      <>
                        <TableCell
                          align="center"
                          className={classes.repHeader}
                          colSpan={1}
                          style={{
                            color: "white",
                            border: "0.5px solid lightgrey",
                            minWidth: 40,
                            maxWidth: 40,
                          }}
                        ></TableCell>
                        <TableCell
                          align="center"
                          className={classes.repHeader}
                          colSpan={1}
                          style={{
                            color: "white",
                            border: "0.5px solid lightgrey",
                            minWidth: 70,
                            maxWidth: 70,
                          }}
                        ></TableCell>
                        {/* <TableCell align='center' className={classes.repHeader} colSpan={1} style={{  color: 'white',border: '0.5px solid lightgrey',minWidth:50,maxWidth:50  }}></TableCell> */}
                      </>
                    ))}
                    <TableCell
                      align="center"
                      rowSpan={1}
                      className={classes.repHeader}
                      colSpan={1}
                      style={{
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 50,
                        maxWidth: 50,
                      }}
                    ></TableCell>
                    <TableCell
                      align="center"
                      rowSpan={1}
                      className={classes.repHeader}
                      colSpan={1}
                      style={{
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 50,
                        maxWidth: 50,
                      }}
                    ></TableCell>
                    <TableCell
                      align="center"
                      rowSpan={1}
                      className={classes.repHeader}
                      colSpan={1}
                      style={{
                        color: "white",
                        border: "0.5px solid lightgrey",
                        minWidth: 50,
                        maxWidth: 50,
                      }}
                    ></TableCell>
                  </StyledTableRow>
                  {teams.map((team) => {
                    const teamData = props.AttainmentTable.filter(
                      (s) => s.name === team
                    );
                    return (
                      <StyledTableRow>
                        <TableCell
                          align="left"
                          className={classes.repHeader}
                          style={{
                            border: "0.5px solid lightgrey",
                            textIndent: "1rem",
                            minWidth: 160,
                          }}
                          colSpan={1}
                        >
                          {team}
                        </TableCell>
                        <TableCell
                          align="right"
                          className={classes.repHeader}
                          style={{
                            border: "0.5px solid lightgrey",
                            paddingRight: "0.5rem",
                          }}
                          colSpan={1}
                        >
                          {"100%"}
                        </TableCell>
                        <TableCell
                          align="right"
                          className={classes.repHeader}
                          style={{
                            border: "0.5px solid lightgrey",
                            paddingRight: "0.5rem",
                          }}
                          colSpan={1}
                        >
                          {Math.round(
                            teamData.filter(
                              (s) => s.type === "total" && s.name === team
                            )[0].actual * 100
                          )}
                          %
                        </TableCell>
                        <TableCell
                          align="right"
                          onClick={() =>
                            props.handleChangeLocation(
                              "drilldownOnGraph",
                              bookingTypes,
                              [team]
                            )
                          }
                          className={classes.repHeader}
                          style={{
                            border: "0.5px solid lightgrey",
                            cursor: "pointer",
                            paddingRight: "0.5rem",
                          }}
                          colSpan={1}
                        >
                          {countOrACVFormatter(
                            teamData.filter((s) => s.type === "total")[0]
                              .attainmentCount
                          )}
                        </TableCell>
                        <TableCell
                          align="right"
                          onClick={() =>
                            props.handleChangeLocation(
                              "drilldownOnGraph",
                              bookingTypes,
                              [team]
                            )
                          }
                          className={classes.repHeader}
                          style={{
                            border: "0.5px solid lightgrey",
                            cursor: "pointer",
                            paddingRight: "0.5rem",
                          }}
                          colSpan={1}
                        >
                          $
                          {countOrACVFormatter(
                            teamData.filter((s) => s.type === "total")[0]
                              .attainmentAcv
                          )}
                        </TableCell>
                        {/* <TableCell align='right' onClick={() => props.handleChangeLocation("drilldownOnGraph", bookingTypes,[team])} className={classes.repHeader} style={{border: '0.5px solid lightgrey',cursor:'pointer',paddingRight:'0.5rem'}} colSpan={1}>{Math.round(teamData.filter(s=>s.type === 'total' && s.name === team)[0].attainmentPerc * 100)}%</TableCell> */}
                        {uniqueNames.map((a) => {
                          return (
                            <>
                              <TableCell
                                align="right"
                                onClick={() =>
                                  props.handleChangeLocation(
                                    "drilldownOnGraph",
                                    [a],
                                    [team]
                                  )
                                }
                                className={classes.repHeader}
                                style={{
                                  border: "0.5px solid lightgrey",
                                  cursor: "pointer",
                                  paddingRight: "0.5rem",
                                }}
                                colSpan={1}
                              >
                                {countOrACVFormatter(
                                  teamData.filter(
                                    (i) => i.type === a && i.name === team
                                  )[0].count
                                )}
                              </TableCell>
                              <TableCell
                                align="right"
                                onClick={() =>
                                  props.handleChangeLocation(
                                    "drilldownOnGraph",
                                    [a],
                                    [team]
                                  )
                                }
                                className={classes.repHeader}
                                style={{
                                  border: "0.5px solid lightgrey",
                                  cursor: "pointer",
                                  paddingRight: "0.5rem",
                                }}
                                colSpan={1}
                              >
                                $
                                {countOrACVFormatter(
                                  teamData.filter(
                                    (i) => i.type === a && i.name === team
                                  )[0].acv
                                )}
                              </TableCell>
                              {/* <TableCell align='right' onClick={() => props.handleChangeLocation("drilldownOnGraph", [a],[team])} className={classes.repHeader} style={{border: '0.5px solid lightgrey',cursor:'pointer',paddingRight:'0.5rem' }} colSpan={1}>{Math.round(teamData.filter(i=>i.type === a && i.name === team)[0].perc * 100)}%</TableCell> */}
                            </>
                          );
                        })}
                        <TableCell
                          align="right"
                          onClick={() =>
                            props.handleChangeLocation(
                              "drilldownOnGraph",
                              bookingTypes,
                              [team]
                            )
                          }
                          className={classes.repHeader}
                          style={{
                            border: "0.5px solid lightgrey",
                            cursor: "pointer",
                            paddingRight: "0.5rem",
                          }}
                          colSpan={1}
                        >
                          $
                          {countOrACVFormatter(
                            teamData.filter((s) => s.type === "total")[0]
                              .services
                          )}
                        </TableCell>
                        <TableCell
                          align="right"
                          className={classes.repHeader}
                          style={{
                            border: "0.5px solid lightgrey",
                            paddingRight: "0.5rem",
                          }}
                          colSpan={1}
                        >
                          $
                          {countOrACVFormatter(
                            teamData.filter((s) => s.type === "total")[0]
                              .bookings
                          )}
                        </TableCell>
                        <TableCell
                          align="right"
                          className={classes.repHeader}
                          style={{
                            border: "0.5px solid lightgrey",
                            paddingRight: "0.5rem",
                          }}
                          colSpan={1}
                        >
                          {countOrACVFormatter(
                            teamData.filter((s) => s.type === "total")[0].quota
                          )}
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
    </>
  );
}
